var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"packs"},[_c('h2',{staticClass:"packs-text"},[_vm._v("we travel in packs")]),_vm._v(" "),_c('picture',{staticClass:"packs-image"},[_c('img',{attrs:{"srcset":require("./../assets/packs-bg.png"),"alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f60e777","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Packs.vue
// module id = null
// module chunks = 